<template>
  <div class="intelligentBox box-shadow">
    <div class="headForm">
      <h4>营销汇总分析</h4>
      <jd-tabs-permission
        :tabInfo="tabsMenu"
        @switch="hugItemBtn"
        @tabIndex="tabIndexChange"
        style="margin: 16px 0 0 16px"
      ></jd-tabs-permission>
      <div class="search-box" v-if="topSelect == 1">
        <el-form :model="formData" label-width="120px" :inline="true">
          <el-form-item label="活动类型">
            <el-select
              v-model="formData.activeType"
              placeholder="请选择"
              style="width: 198px; vertical-align: middle"
              @change="actType"
            >
              <el-option
                v-for="item in activeSelect"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- 当选择智能营销时，新增二级联动 -->
            <el-select
              v-if="isShowActiveSelect"
              v-model="formData.type"
              placeholder="请选择"
              style="width: 220px; vertical-align: middle; margin-left: 8px"
              v-loading="selectLoading"
            >
              <el-option
                v-for="item in activityList"
                :key="item.outerId"
                :label="item.name"
                :value="item.outerId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="短信类型">
            <el-select
              v-model="formData.smsType"
              placeholder="请选择"
              style="width: 198px; vertical-align: middle"
            >
              <el-option
                v-for="item in smsSelect"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发送时间">
            <div style="display: flex">
              <el-select
                v-model="formData.effectDay"
                placeholder="请选择"
                style="width: 90px; margin-right: 8px; vertical-align: middle"
                @change="switchType"
              >
                <el-option
                  v-for="item in timeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formData.sendStartTime"
                  type="date"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 100px; font-size: 12px"
                  class="time1"
                  :disabled="formData.effectDay ? true : false"
                  :picker-options="pickerOptionsStart"
                  :clearable="false"
                  @change="handleChange"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formData.sendEndTime"
                  type="date"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 105px; font-size: 12px"
                  class="time2"
                  :disabled="formData.effectDay ? true : false"
                  :picker-options="pickerOptionsEnd"
                  @change="handleChange"
                  :clearable="false"
                ></el-date-picker>
                <i class="el-icon-circle-close date_icon1"></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="效果统计时间">
            <div style="display: flex">
              <el-select
                v-model="formData.typeNum"
                placeholder="请选择"
                style="width: 90px; margin-right: 8px; vertical-align: middle"
                @change="switchType1"
              >
                <el-option
                  v-for="item in timeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div style="display: flex" v-if="isShowTime">
                <el-select
                  v-model="formData.effectDayType"
                  placeholder="请选择"
                  style="
                    width: 100px;
                    margin-right: 8px;
                    vertical-align: middle;
                  "
                  @change="handleDay"
                >
                  <el-option
                    v-for="item in effectType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <div class="my_select_time" v-if="!isShowDay">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="formData.startTime"
                    type="date"
                    :placeholder="'选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 105px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                    :disabled="formData.effectDay ? true : false"
                    :picker-options="pickerOptionsStart1"
                    @change="handleChanges"
                  ></el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="formData.endTime"
                    type="date"
                    :placeholder="'选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 105px; font-size: 12px"
                    class="time2"
                    :picker-options="pickerOptionsEnd1"
                    @change="handleChanges"
                    :disabled="formData.effectDay ? true : false"
                    :clearable="false"
                  ></el-date-picker>
                  <i class="el-icon-circle-close date_icon1"></i>
                  <img
                    src="@/assets/images/select_date.svg"
                    alt
                    class="date_icon2"
                  />
                </div>
                <div style="display: inline-block" v-if="isShowDay">
                  <span>近</span>
                  <el-input
                    style="width: 120px; margin: 0 8px"
                    v-model="formData.day"
                  ></el-input>
                  <span>天</span>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="btn_group">
          <el-button
            size="small"
            :disabled="tableLoading"
            class="search"
            @click="handleSearch"
          >
            <i
              class="el-icon-search"
              style="display: inline-block; width: 14px; height: 12px"
            ></i>
            查询
          </el-button>
          <el-button size="small" class="reset" @click="reset">重置</el-button>
        </div>
      </div>
      <div class="search-box" v-if="topSelect == 2">
        <el-form :inline="true" :model="formData_one" label-width="120px">
          <el-form-item label="活动批次：">
            <el-select
              v-model="formData_one.activeType"
              placeholder="请选择"
              style="width: 140px; margin-right: 12px; vertical-align: middle"
              @change="actTypes"
            >
              <el-option
                v-for="item in activeSelect_one"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="formData_one.type"
              placeholder="请选择"
              style="width: 220px; margin-right: 12px; vertical-align: middle"
              filterable
            >
              <el-option
                v-for="item in timeTypes"
                :key="item.outerId"
                :label="item.name"
                :value="item.outerId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计时间">
            <div style="display: flex">
              <el-select
                v-model="formData_one.types"
                placeholder="请选择"
                style="width: 140px; margin-right: 12px; vertical-align: middle"
                @change="switchType2"
              >
                <el-option
                  v-for="item in timeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formData_one.startTime"
                  type="date"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="formData_one.types ? true : false"
                  :picker-options="pickerOptionsStart1"
                  @change="handleChange_one"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formData_one.endTime"
                  type="date"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 145px; font-size: 12px"
                  class="time2"
                  :picker-options="pickerOptionsEnd1"
                  :disabled="formData_one.types ? true : false"
                  @change="handleChange_one"
                  :clearable="false"
                ></el-date-picker>
                <i class="el-icon-circle-close date_icon1"></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="btn_group">
          <el-button
            size="small"
            :disabled="tableLoading"
            class="search"
            @click="handleSearchs"
          >
            <i
              class="el-icon-search"
              style="display: inline-block; width: 14px; height: 12px"
            ></i>
            查询
          </el-button>
          <el-button size="small" class="reset" @click="reset_one"
            >重置</el-button
          >
          <el-button @click="exportDataOne">导出数据</el-button>
        </div>
        <div class="tip-box" style="margin: 20px 0 0 25px;">
          <i class="el-icon-warning warning-icon"></i>
          <el-popover
            placement="bottom-start"
            title=""
            width="380"
            trigger="hover"
            content="营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供，无法查看到会员明细数据"
          >
            <span style="color: #333" slot="reference"
              >营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供，无法查看到会员明细数据</span
            >
          </el-popover>
        </div>
        <div class="info-box">
          <div class="roi-box-wrap">
            <div class="roi-box">
              <div class="roi">ROI</div>
              <div class="roi-data">
                <div>
                  <span>ROI（投入产出比）</span>
                  <el-tooltip class="item" effect="light" :content="roiTip" placement="top">
                    <span class="question_icon">?</span>
                  </el-tooltip>
                  <span class="update-btn" @click="updateROI">修改</span>
                </div>
                <div class="value">{{ roi }}</div>
              </div>
              <div class="roi-update"></div>
            </div>
          </div>

          <div class="task-content">
            <div>任务名称：{{ effectDatas.activityTitle }}</div>
            <div>
              状态： <span class="send-status">已发送</span> 实际触达人数：<span class="send-status num">{{ effectDatas.sendNum }}人</span
              >
              营销成本：<span class="num">{{ effectDatas.marketingCosts }}元</span
              >
            </div>
            <div>
              <div v-if="effectDatas.smsType == 1">短信内容：<span class="rich_title" @click="showMediaInfo">{{ effectDatas.mediaTitle }}</span></div>
              <div v-else>短信内容：{{ effectDatas.content }}</div>
            </div>
          </div>
        </div>
        <div class="tab-roi-box">
          <el-tabs v-model="switchIndex" @tab-click="switchTab">
            <el-tab-pane label="汇总" name="0"></el-tab-pane>
            <el-tab-pane label="触达" name="1"></el-tab-pane>
            <el-tab-pane label="点击" name="2"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="top-content" v-loading="tableLoading">
          <div
            class="top-item"
            v-for="(item, index) in effectList_one"
            :key="index"
            :style="{
              marginRight: item.title == '会员购买分析' ? '0' : '20px',
            }"
          >
            <div class="title">
              <img
                :src="item.icon"
                alt=""
                style="width: 20px; height: 20px; margin-right: 4px"
              />
              <span>{{ item.title }}</span>
            </div>
            <div class="content">
              <p v-for="(eItem, eIndex) in item.dataList" :key="eIndex">
                {{ eItem.name }} {{ eItem.value ? eItem.value : "--" }}
                {{ eItem.unit }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- 短信营销数据总览 -->
      <div class="section-right-content-box" v-if="topSelect == 1">
        <!-- 导出数据 -->
        <div class="top-title">
          <div class="title-left">
            <div class="background" style="margin-right: 20px">
              <span class="title"></span>&nbsp;
              <span class="tips">活动数据分析</span>
            </div>
          </div>
          <span>
            <el-button @click="fieldSetting">字段配置</el-button>
            <el-button @click="exportData">导出数据</el-button>
          </span>
        </div>
        <div style="margin-top: 20px" class="table-style">
          <el-table
            ref="tableRef"
            :data="tableData"
            :header-cell-style="{
              background: '#fafafa',
              'text-align': 'left',
            }"
            :cell-style="{ 'text-align': 'left' }"
            v-loading="tableLoading"
            style="position: relative"
            max-height="550"
            @sort-change="handleSortChange"
          >
            <!-- :summary-method="getSummaries" show-summary -->
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              v-for="item in tableInfo"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="widthChange(item.prop) ? '220' : '160'"
              :sortable="sortChange(item.prop)"
              :fixed="isFixed(item.prop)"
            >
              <template slot="header" slot-scope="scope">
                <span v-if="item.prop=='marketingCosts'">营销成本</span>
                <span v-else>{{ item.label }}</span>
                <el-tooltip v-if="item.prop=='marketingCosts'" effect="dark" placement="top">
                  <div slot="content">营销成本=短信成功扣费条数*短信单价<br/>普通短信：0.05元，富信：0.42元，卡片短信0.38元</div>
                  <i class="el-icon-question" style="margin-left: 4px;"></i>
                </el-tooltip>  
                <span
                  @click="isShowTextAll"
                  style="padding-left:10px; cursor: pointer;"
                  v-if="item.prop=='content'"
                  >
                  <span v-show="isShowAll"
                  :style="{ color: '#7f85e9' }"
                  >（收起全部）
                  </span>
                  <span v-show="!isShowAll"
                  :style="{ color: '#7f85e9' }"
                  >（展开全部）
                  </span>
                </span>                
              </template>
              <template  slot-scope="scope">
                <span v-if="item.prop=='content'" >
                  <span v-if="!isShowAll" class="box-content">{{  scope.row.content }}</span>
                  <span v-else>{{  scope.row.content }}</span>
                </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <span
                  @click="handeleEffect(scope.row)"
                  style="color: #2768ff; cursor: pointer"
                  v-if="scope.row.activityTitle != '总计'"
                  >效果分析</span
                >
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 20px">
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">商品数据分析</span>
          </div>
          <div style="margin-top: 20px">
            <el-table
              :data="goodsData"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
              max-height="550"
              v-loading="goodsLoading"
              style="position: relative"
            >
              <template slot="empty">
                <div>
                  <img src="@/assets/images/default/暂无任何数据.png" />
                  <span style="margin-left: -140px">暂无任何数据</span>
                </div>
              </template>
              <el-table-column
                v-for="item in goodsInfo"
                :key="item.prop"
                :prop="item.prop"
                :label="item.label"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 单批次短信效果分析 -->
      <div v-if="topSelect == 2">
        <div class="section-right-content-box">
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">趋势分析</span>
          </div>
          <!-- <jd-title label="趋势分析" type="bold"></jd-title> -->
          <div class="trend-wrap">
            <div class="trend-box-x">
              <div
                class="trend-item"
                v-for="(item, index) in trendingListX_one"
                :key="index"
              >
                <div class="type-title">{{ item.title }}</div>
                <div class="trend-radio">
                  <template v-for="(trendItem, trendIndex) in item.data">
                    <el-radio
                      :style="{
                        width: index != '3' ? '170px' : '240px',
                        'margin-right': '0',
                      }"
                      :key="trendIndex"
                      @change="getTrendValues(trendItem)"
                      v-model="trendKey"
                      :label="trendItem.key"
                    >
                      <span style="color: #666">{{ trendItem.name }}</span>
                    </el-radio>
                  </template>
                </div>
              </div>
            </div>
            <div class="trend-box">
              <div class="echart-box">
                <echarts
                  :legendShow="false"
                  :key="trendKey"
                  :seriesData="seriesData"
                  :echartsDate="echartsDate"
                ></echarts>
              </div>
            </div>
          </div>
        </div>
        <div class="section-right-content-box good-analysis">
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">TOP100商品分析</span>
          </div>
          <div style="margin: 16px 0;">
            <span>排序规则：</span>
            <el-select
              key="collationValue"
              v-model="collationValue"
              style="width: 208px;"
              @change="selectChange"
              placeholder="请选择">
              <el-option
                v-for="item in collationList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="tip-box">
            <i class="el-icon-warning warning-icon"></i>
            <el-popover
              placement="bottom-start"
              title=""
              width="380"
              trigger="hover"
              content="列表中 “/” 代表无法获取该数据，数据未进入浏览、加购、付款商品的TOP100"
            >
              <span style="color: #333" slot="reference"
                >列表中 “/” 代表无法获取该数据，数据未进入浏览、加购、付款商品的TOP100</span
              >
            </el-popover>
          </div>
          <div class="goods-item" style="margin-top: 16px">
            <el-table
              ref="goodsTable"
              :data="topGoods"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
              tooltip-effect="light"
              style="width: 100%; border: 1px solid #eee"
              stripe
              v-loading="tableLoading"
            >
              <el-table-column label="序号" width="50px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="商品信息" width="240px">
                <template slot-scope="scope">
                  <div class="goods-box">
                    <img :src="scope.row.picUrl" alt="" />
                    <div>
                      <el-tooltip class="item" effect="dark" :content="scope.row.skuName" placement="right">
                        <p class="shop-title">
                          {{ scope.row.skuName }}
                        </p>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="'skuid:' + scope.row.skuId" placement="right">
                        <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="browsePv" min-width="90px" label="浏览PV(次数)">
                <template slot-scope="scope">
                  <span>{{ scope.row.browsePv > 0 ? scope.row.browsePv : '/' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="browseUv" min-width="90px" label="浏览UV(人数)">
                <template slot-scope="scope">
                  <span>{{ scope.row.browseUv > 0 ? scope.row.browseUv : '/' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cartUserNum" label="加购人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.cartUserNum > 0 ? scope.row.cartUserNum : '/' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cartSkuNum" label="加购件数">
                <template slot-scope="scope">
                  <span>{{ scope.row.cartSkuNum > 0 ? scope.row.cartSkuNum : '/' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="payUserNum" label="付款人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.payUserNum > 0 ? scope.row.payUserNum : '/' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="paySkuNum" label="付款件数">
                <template slot-scope="scope">
                  <span>{{ scope.row.paySkuNum > 0 ? scope.row.paySkuNum : '/' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="payAmount" label="付款金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.payAmount > 0 ? scope.row.payAmount : '/' }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- <div class="goods-item">
            <div class="goods-title">浏览商品TOP10</div>
            <el-table
              ref="goodsTable"
              sum-text="合计"
              show-summary
              :data="browseGoods_one"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
              tooltip-effect="light"
              style="width: 100%; border: 1px solid #eee"
              stripe
              v-loading="tableLoading"
            >
              <el-table-column label="序号" width="50px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="商品">
                <template slot-scope="scope">
                  <div class="goods-box">
                    <img :src="scope.row.picUrl" alt="" />
                    <div>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.wareName"
                        placement="right"
                      >
                        <p class="shop-title">
                          {{ scope.row.wareName }}
                        </p>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="'skuid:' + scope.row.skuId"
                        placement="right"
                      >
                        <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="80"
                prop="pv"
                sortable
                label="PV(次数)"
              ></el-table-column>
              <el-table-column
                width="80"
                prop="uv"
                sortable
                label="UV(人)"
              ></el-table-column>
            </el-table>
          </div>
          <div class="goods-item">
            <div class="goods-title">加购商品TOP10</div>
            <el-table
              ref="goodsTable"
              sum-text="合计"
              show-summary
              :data="cartGoods_one"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
              tooltip-effect="light"
              style="width: 100%; border: 1px solid #eee"
              stripe
              v-loading="tableLoading"
            >
              <el-table-column label="序号" width="50px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="商品">
                <template slot-scope="scope">
                  <div class="goods-box">
                    <img :src="scope.row.picUrl" alt="" />
                    <div>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.wareName"
                        placement="right"
                      >
                        <p class="shop-title">
                          {{ scope.row.wareName }}
                        </p>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="'skuid:' + scope.row.skuId"
                        placement="right"
                      >
                        <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="80px"
                prop="userNum"
                sortable
                label="加购人数"
              ></el-table-column>
              <el-table-column
                width="80px"
                prop="skuNum"
                sortable
                label="加购件数"
              ></el-table-column>
            </el-table>
          </div>
          <div class="goods-item" style="width: 590px">
            <div class="goods-title">付款商品TOP10</div>
            <el-table
              ref="goodsTable"
              sum-text="合计"
              show-summary
              :data="payGoods_one"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
              tooltip-effect="light"
              style="width: 100%; border: 1px solid #eee"
              stripe
              v-loading="tableLoading"
            >
              <el-table-column label="序号" width="50px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="商品">
                <template slot-scope="scope">
                  <div class="goods-box">
                    <img :src="scope.row.picUrl" alt="" />
                    <div>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.wareName"
                        placement="right"
                      >
                        <p class="shop-title">
                          {{ scope.row.wareName }}
                        </p>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="'skuid:' + scope.row.skuId"
                        placement="right"
                      >
                        <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="110"
                prop="userNum"
                sortable
                label="付款人数"
              ></el-table-column>
              <el-table-column
                width="100"
                prop="skuNum"
                sortable
                label="付款件数"
              ></el-table-column>
              <el-table-column
                width="100"
                prop="amount"
                sortable
                label="付款金额"
              ></el-table-column>
            </el-table>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 生成报表 -->
    <generate
      :control="control"
      v-if="control"
      @transData="(val) => (control = val)"
      @transData1="getphone1"
    ></generate>

    <!-- 单批次 -->
    <generate
      :control="control1"
      v-if="control1"
      @transData="(val) => (control1 = val)"
      @transData1="getphone2"
    ></generate>
    <!-- 字段配置 -->
    <fieldSetting
      :isShowSetting="isShowSetting"
      @close="isShowSetting = false"
      v-if="isShowSetting"
      @reData="reData"
    ></fieldSetting>
     <!--修改单价弹窗-->
     <el-dialog title="修改单价" :visible.sync="updateState" width="30%">
      <div>
        <el-input type="number" v-model="unitPrice" clearable style="width: 90%"></el-input>
        <span style="width: 10%">元/条</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateState = false">取 消</el-button>
        <el-button type="primary" @click="updateROI">保 存</el-button>
      </span>
    </el-dialog>
     <!-- 富信模板 -->
     <sms-info 
      v-if="smsInfoShow" 
      @close="smsInfoShow = false" 
      :isShow="smsInfoShow" 
      :id="smsInfoId"
      :title="smsInfoTitle"
      :text="smsInfoText"
    />
  </div>
</template>

<script>
import echarts from "@/components/echarts.vue";
import {
  summaryV2Data,
  summaryExport,
  summaryDetail,
  getSelectBatch,
  getOfficialData,
  summaryExport1,
  fieldJsonConfig,
  getAnalyzesku,
} from "@/api/smsMarketing";
import { updateUnitPrice } from "@/api/sellerController";
import generate from "../../components/generate_report.vue";
import fieldSetting from "@/views/manage/components/fieldSetting.vue";
import smsInfo from '@/components/sms-info'
import { mapState } from "vuex";
// import JdTitle from "../../components/new/jd-title.vue";
export default {
  name: "SmsMarketingEffect",
  data() {
    return {
      smsInfoShow: false, // 富信
      smsInfoId: "", // 富信id
      smsInfoTitle: "", // 富信标题
      smsInfoText: "", // 富信内容
      isShowAll: false,
      updateState: false,
      unitPrice: "",
      shopList: [],
      goodsData: [],
      goodsLoading: false,
      goodsInfo: [
        {
          prop: "skuId",
          label: "skuId",
        },
        {
          prop: "skuName",
          label: "商品名称",
        },
        {
          prop: "browsePv",
          label: "pv(次数)",
        },
        {
          prop: "browseUv",
          label: "uv(次数)",
        },
        {
          prop: "cartUserNum",
          label: "加购人数",
        },
        {
          prop: "cartSkuNum",
          label: "加购件数",
        },
        {
          prop: "payUserNum",
          label: "付款人数",
        },
        {
          prop: "paySkuNum",
          label: "付款件数",
        },
        {
          prop: "payAmount",
          label: "付款金额",
        },
      ],
      isShowSetting: false,
      tableInfo: [
        {
          prop: "sellerNick",
          label: "店铺名称",
        },
        {
          prop: "activityTitle",
          label: "活动主题",
        },
        {
          prop: "content",
          label: "短信内容",
        },
        {
          prop: "sendTime",
          label: "发送时间",
        },
        {
          prop: "roi",
          label: "ROI（投入产出比）",
        },
        {
          prop: "sendNum",
          label: "实际触达人数",
        },
        {
          prop: "pv",
          label: "短链点击PV",
        },
        {
          prop: "uv",
          label: "短链点击UV",
        },
        {
          prop: "clickRate",
          label: "短链点击率（%）",
        },
        {
          prop: "orderRate",
          label: "下单转化率（%）",
        },
        {
          prop: "ordPins",
          label: "下单人数",
        },
        {
          prop: "ordAmount",
          label: "下单金额",
        },
        {
          prop: "ordNum",
          label: "下单订单数",
        },
        {
          prop: "ordQtty",
          label: "下单件数",
        },
        {
          prop: "orderPayRate",
          label: "下单-付款转化率（%）",
        },
        {
          prop: "payRate",
          label: "付款转化率（%）",
        },
        {
          prop: "payPins",
          label: "付款人数",
        },
        {
          prop: "payAmount",
          label: "付款金额",
        },
        {
          prop: "payNum",
          label: "付款订单数",
        },
        {
          prop: "payQtty",
          label: "付款件数",
        },
        {
          prop: "perCustomerTransaction",
          label: "客单价",
        },
        {
          prop: "cartNum",
          label: "加购人数",
        },
      ],
      tableData: [],
      dataDetails: {
        total: 0, //总活动
        totalNum: 0, //总批次
        successNum: 0, //成功批次
        failNum: 0, //失败
        waitSendNum: 0, //发送
      },
      tabsMenu: [
        {
          value: 1,
          label: "营销数据总览",
        },
        {
          value: 2,
          label: "营销数据快捷查看",
        },
      ],
      shopMemberType: "",
      shopMemberType_one: "",
      // 分析数据
      trendingListX: [], //趋势分析
      trendingListX_one: [],
      trendKey: "", //图表值
      trendKey_one: "", //图表值
      seriesData: [], // 图表所需的趋势分析数据
      echartsDate: [],
      browseGoods: [], // 浏览商品
      browseGoods_one: [],
      cartGoods: [], // 加购商品
      cartGoods_one: [],
      payGoods: [], // 付款商品
      payGoods_one: [],
      topGoods: [], // top100
      tableLoading: false,
      effectData: {}, // 效果分析数据
      effectData_one: {},
      //短信营销数据总览
      control: false,
      control1: false,
      //获取活动类型对应的字段
      activeTypes: "", //PRECISION_MARKETING
      dataFroms: "",
      //单批次
      activeTypesOne: "PRECISION_MARKETING",
      dataFromsOne: "",
      //短信营销数据总览
      topSelect: 1, //头部切换栏
      activeSelect: [
        //活动类型
        {
          label: "全部",
          value: "",
        },
        {
          label: "精准营销",
          value: "1",
        },
        {
          label: "智能营销",
          value: "2",
        },
        {
          label: "会员发送",
          value: "3",
        },
        {
          label: "订单发送",
          value: "4",
        },
        {
          label: "预售订单发送",
          value: "5",
        },
      ],
      activeList: [
        //活动名称
        {
          name: "全部",
          outerId: "",
        },
        {
          name: "活动1",
          outerId: "1",
        },
      ],
      activeSelect_one: [
        //活动类型
        {
          label: "精准营销",
          value: "1",
        },
        {
          label: "智能营销",
          value: "2",
        },
        {
          label: "会员发送",
          value: "3",
        },
        {
          label: "订单发送",
          value: "4",
        },
        {
          label: "预售订单发送",
          value: "5",
        },
      ],
      smsSelect: [
        //活动类型
        {
          label: "全部",
          value: "",
        },
        {
          label: "普通短信",
          value: "0",
        },
        {
          label: "富信",
          value: "1",
        },
        {
          label: "卡片短信",
          value: "2",
        },
      ],
      formData: {
        startTime: "",
        endTime: "",
        effectDay: "30",
        typeNum: "7",
        activeType: "", //活动类型
        smsType: "", //短信类型
        sendStartTime: "", //发送开始时间
        sendEndTime: "", //发送结束时间
        activeName: "", //活动名称
        effectDayType: 0,
        type: undefined,
        day: "",
      },
      formData_one: {
        startTime: "",
        endTime: "",
        type: "",
        activeType: "1", //活动类型
        smsType: "", //短信类型
        types: "7",
      },

      //end
      //单批次时间切换
      timeType: [
        {
          label: "自定义",
          value: "",
        },
        {
          label: "近3天",
          value: "3",
        },
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
      ],
      effectType: [
        {
          label: "相对时间",
          value: 0,
        },
        {
          label: "绝对时间",
          value: 1,
        },
      ],
      fieldType: 1,
      isShowActiveSelect: false,
      selectLoading: false,
      timeTypes: [],
      activityList: [],
      switchIndex: 0,
      effectList: [],
      effectList_one: [],
      effectDatas: [], //单批次
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.formData.sendStartTime) {
            return (
              time.getTime() < new Date(this.formData.sendStartTime).getTime()
            );
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.formData.sendEndTime) {
            return (
              time.getTime() > new Date(this.formData.sendEndTime).getTime()
            );
          }
        },
      },
      pickerOptionsEnd1: {
        disabledDate: (time) => {
          if (this.formData.startTime) {
            return time.getTime() < new Date(this.formData.startTime).getTime();
          }
          if (this.formData_one.startTime) {
            return (
              time.getTime() < new Date(this.formData_one.startTime).getTime()
            );
          }
        },
      },
      pickerOptionsStart1: {
        disabledDate: (time) => {
          if (this.formData.endTime) {
            return time.getTime() > new Date(this.formData.endTime).getTime();
          }
          if (this.formData_one.endTime) {
            return (
              time.getTime() > new Date(this.formData_one.endTime).getTime()
            );
          }
        },
      },
      //end
      collationValue: "payUserNum", // 排序规则
      collationList: [
        { label: '按浏览PV（次数）', value: 'browsePv'},
        { label: '按浏览UV（人数）', value: 'browseUv'},
        { label: '按加购人数', value: 'cartUserNum'},
        { label: '按加购件数', value: 'cartSkuNum'},
        { label: '按付款人数', value: 'payUserNum'},
        { label: '按付款件数', value: 'paySkuNum'},
        { label: '按付款金额', value: 'payAmount'},
      ], // 排序选项
      roi: "",
    };
  },
  components: {
    echarts,
    generate,
    // JdTitle,
    fieldSetting,
    smsInfo
  },
  computed: {
    ...mapState({
      roiTip: "roiTip"
    }),
    isShowTime() {
      return !this.formData.typeNum;
    },
    isShowDay() {
      return this.formData.effectDayType == 0;
    },
    isFixed() {
      return (key)=>{
        let keys = ["sellerNick","activityTitle","content"]
        return keys.includes(key)
      }
    }
  },
  mounted() {
    //短信效果汇总默认时间
    var day = "";
    this.fieldJsonConfigQuery();
    this.switchType(this.formData.effectDay);
    this.switchType1(day);
    this.switchType2(this.formData_one.types);
    this.handleGetAnalyzesku();
    this.getSelectBatch();
    this.buriedPoint(1, "短信效果汇总", "营销管理", "短信效果汇总");
  },
  methods: {
    // 展示富短信内容
    showMediaInfo() {
      this.smsInfoShow = true
      this.smsInfoId = this.effectDatas.mediaMulitiFileId
      this.smsInfoTitle = this.effectDatas.mediaTitle
      this.smsInfoText = this.effectDatas.content
    },
    doLayouts() {
      var that = this;
      this.$nextTick(() => {
        that.$refs.tableRef.doLayout();
        var tableBox = that.$refs.tableRef.$vnode.elm;
        var tbody = tableBox.getElementsByTagName("tbody");
        var tableTbody = tbody[0];
        var fixedTbody = tbody[1];
        var tableTrs = tableTbody.getElementsByTagName("tr");
        var fixedTrs = fixedTbody.getElementsByTagName("tr");

        for (var i = 0; i < tableTrs.length; i++) {
          fixedTrs[i].style.height = tableTrs[i].offsetHeight + "px";
        }
      });
    },
    isShowTextAll() {
      this.isShowAll = !this.isShowAll;
      this.doLayouts()
    },
    // 修改单价
    updateROI() {
      if (this.updateState) {
        updateUnitPrice( this.effectDatas.smsType == 1 ? 1 : this.effectDatas.smsType == 2 ? 2: 0, this.unitPrice ).then((res) => {
          if (res.code == "1") {
            this.$message.success("修改成功！");
            this.getEffectDatas();
          } else {
            this.$message.error(res.message);
          }
        });
      }
      this.updateState = !this.updateState;
    },
    async handleGetAnalyzesku() {
      var param = {
        startTime:
          this.formData.effectDayType == 1
            ? this.formData.startTime
            : undefined,
        endTime:
          this.formData.effectDayType == 1 ? this.formData.endTime : undefined,
        source: this.activeTypes,
        dataFrom: this.dataFroms,
        effectDayType: this.formData.effectDayType,
        effectDay:
          !this.isShowTime || !this.isShowDay
            ? this.formData.typeNum
            : this.formData.day,
        sendStartTime: this.formData.sendStartTime
          ? this.formData.sendStartTime + " 00:00:00"
          : this.formData.sendStartTime,
        sendEndTime: this.formData.sendEndTime
          ? this.formData.sendEndTime + " 23:59:59"
          : this.formData.sendEndTime,
        smsType: this.formData.smsType, //短信类型
        outerId: this.formData.type, //活动Id
      };
      try {
        this.goodsLoading = true;
        const res = await getAnalyzesku(param);
        if (res.code == 1) {
          this.goodsData = res.data;
          this.goodsLoading = false;
        }
      } catch (error) {
        this.goodsLoading = false;
      }
    },
    tabIndexChange(val) {
      this.topSelect = val;
    },
    handleSortChange(column) {
      let fieldName = column.prop;
      let sortingType = column.order;
      let avgData = {};
      if (this.tableData.length) {
        this.tableData.map((item) => {
          if (item.sellerNick == "总计") {
            avgData = item;
          }
        });
        if (sortingType == "ascending") {
          this.tableData.map((item, index) => {
            if (item.sellerNick == "总计") {
              this.tableData.splice(index, 1);
            }
            return item;
          });
          //正序
          this.tableData.sort((a, b) => {
            if (fieldName!="marketingCosts" && typeof a[fieldName] == "string") {
              return a[fieldName].localeCompare(b[fieldName]);
            } else if (typeof Number(a[fieldName]) == "number") {
              return Number(a[fieldName]) - Number(b[fieldName]);
            }
          });
          this.tableData.unshift(avgData);
        } else if (sortingType == "descending") {
          this.tableData.map((item, index) => {
            if (item.sellerNick == "总计") {
              this.tableData.splice(index, 1);
            }
            return item;
          });
          // 倒序
          this.tableData.sort((a, b) => {
            if (fieldName!="marketingCosts" && typeof b[fieldName] == "string") {
              return b[fieldName].localeCompare(a[fieldName]);
            } else if (typeof Number(a[fieldName]) == "number") {
              return Number(b[fieldName]) - Number(a[fieldName]);
            }
          });
          this.tableData.unshift(avgData);
        } else {
          this.$refs.tableRef.clearSort(); // 清除排序
        }
      }
    },
    handleDay(val) {
      if (val == 1) {
        this.formData.startTime = "";
        this.formData.endTime = "";
      }
    },
    widthChange(prop) {
      if (
        [
          "memberBuyPins",
          "brandMemberBuyPins",
          "cardMemberBuyPins",
          "brandMemberNewBuyPins",
          "cardMemberNewBuyPins",
          "roi",
          "clickRate",
          "orderRate",
          "orderPayRate",
          "content"
        ].includes(prop)
      ) {
        return true;
      } else {
        return false;
      }
    },
    sortChange(prop) {
      if (prop == "content" || prop == "activityTitle") {
        return false;
      } else {
        return "custom";
      }
    },
    async fieldJsonConfigQuery() {
      try {
        const res = await fieldJsonConfig({ type: this.fieldType });
        if (res.code == 1) {
          if (res.data && res.data.fieldJson) {
            this.tableInfo = res.data.fieldJson
              ? JSON.parse(res.data.fieldJson)
              : [];
            if (this.tableInfo.some((item) => item.prop == "sendTime")) {
              this.$nextTick(() => {
                this.$refs.tableRef.sort("sendTime", "descending");
              });
            }
          }
          this.getEffectData();
        }
      } catch (error) {}
    },
    reData() {
      this.isShowSetting = false;
      this.fieldJsonConfigQuery();
    },
    // 效果分析跳转
    handeleEffect(row) {
      const officialObj = {
        outerId: row.outerId,
        source: row.source,
        sendTime: row.sendTime,
      };
      this.$emit("showEffect", officialObj);
      // 跳转到新标签页
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/intelligent_market",
        query: {
          outerId: row.outerId,
          source: row.source,
          sendTime: row.sendTime,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    //数据汇总详情
    summaryDetail() {
      let params = {
        source: this.activeTypes,
        dataFrom: this.dataFroms,
        sendStartTime: this.formData.sendStartTime + " 00:00:00",
        sendEndTime: this.formData.sendEndTime + " 23:59:59",
        smsType: this.formData.smsType, //短信类型
        // sortField: this.formData.sortField,
        // asc: this.formData.asc,
      };
      summaryDetail(params).then((res) => {
        this.dataDetails = { ...res.data };
      });
    },
    //切换tab
    hugItemBtn(type) {
      this.topSelect = type;
      if (type == 2) {
        this.formData_one.type = this.timeTypes[0].outerId;
        this.handleSearchs();
      } else {
        this.isShowActiveSelect = false;
        this.formData.type = undefined;
        this.$nextTick(() => {
          this.$refs.tableRef.sort("sendTime", "descending");
        });
        this.handleSearch();
      }
    },
    //单批次短信效果分析
    switchType(val) {
      if (!val) {
        this.formData.sendStartTime = "";
        this.formData.sendEndTime = "";
      } else {
        this.formData.sendStartTime = this.getDay(-val, "-");
        this.formData.sendEndTime = this.getDay(-1, "-");
      }
    },
    switchType1(val) {
      if (!val) {
        this.formData.day = "";
        this.formData.effectDayType = 0;
        this.formData.startTime = "";
        this.formData.endTime = "";
      } else {
        var startTime = "";
        var ss = new Date();
        ss.setDate(ss.getDate());
        var ys = ss.getFullYear();
        var ms =
          ss.getMonth() + 1 < 10
            ? "0" + (ss.getMonth() + 1)
            : ss.getMonth() + 1;
        var ds = ss.getDate() < 10 ? "0" + ss.getDate() : ss.getDate() - 1;
        // ds = ds<10 ? '0'+ds:ds
        startTime = ys + "-" + ms + "-" + ds;
        this.formData.endTime = startTime;
        this.formData_one.endTime = startTime;
        //单批次汇总
        this.formData_one.startTime = startTime;
        var dd = new Date(startTime);
        dd.setDate(dd.getDate() - +val);
        var y = dd.getFullYear();
        var m =
          dd.getMonth() + 1 < 10
            ? "0" + (dd.getMonth() + 1)
            : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        var endTime = y + "-" + m + "-" + d;
        this.formData.startTime = endTime;
        this.formData_one.startTime = endTime;
      }
    },
    switchType2(val) {
      this.formData_one.startTime = this.getDay(-val, "-");
      this.formData_one.endTime = this.getDay(-1, "-");
    },
    //汇总查询
    handleSearch() {
      this.getEffectData();
      this.handleGetAnalyzesku();
    },
    //单批次短信查询
    handleSearchs() {
      this.getEffectDatas();
      //this.summaryDetail()
    },

    //短信营销数据总览活动类型
    actType(e) {
      this.activityList = [];
      if (e == 1) {
        this.activeTypes = "PRECISION_MARKETING";
        this.dataFroms = "";
        this.isShowActiveSelect = false;
      } else if (e == 2) {
        this.activeTypes = "INTELLIGENT_MARKETING";
        this.dataFroms = "";
        this.isShowActiveSelect = true;
        let nums = {
          source: this.activeTypes,
          dataFrom: this.dataFroms,
          type: 1,
        };
        this.selectLoading = true;
        getSelectBatch(nums).then((res) => {
          this.selectLoading = false;
          this.activityList = res.data;
          this.activityList.unshift({
            name: "全部",
            outerId: undefined,
          });
          this.formData.type = res.data[0].outerId;
        });
      } else if (e == 3 || e == 4 || e == 5) {
        this.activeTypes = "PACKAGE_SEND";
        this.isShowActiveSelect = false;
        if (e == 3) {
          this.dataFroms = 1;
        } else if (e == 4) {
          this.dataFroms = 2;
        } else if (e == 5) {
          this.dataFroms = 15;
        }
      } else {
        this.activeTypes = "";
        this.dataFroms = "";
        this.isShowActiveSelect = false;
      }
    },
    //单批次活动类型
    actTypes(e) {
      if (e == 1) {
        this.activeTypesOne = "PRECISION_MARKETING";
      } else if (e == 2) {
        this.activeTypesOne = "INTELLIGENT_MARKETING";
      } else if (e == 3 || e == 4 || e == 5) {
        this.activeTypesOne = "PACKAGE_SEND";
        if (e == 3) {
          this.dataFromsOne = 1;
        } else if (e == 4) {
          this.dataFromsOne = 2;
        } else if (e == 5) {
          this.dataFromsOne = 15;
        }
      }
      this.timeTypes = [];
      let nums = {
        source: this.activeTypesOne,
        dataFrom: this.dataFromsOne,
        // type: 1
      };
      getSelectBatch(nums).then((res) => {
        this.timeTypes = res.data;
        this.formData_one.type = res.data[0].outerId;
      });
    },
    getEffectData() {
      //短信营销数据总览
      var param = {
        startTime:
          this.formData.effectDayType == 1
            ? this.formData.startTime
            : undefined,
        endTime:
          this.formData.effectDayType == 1 ? this.formData.endTime : undefined,
        source: this.activeTypes,
        dataFrom: this.dataFroms,
        effectDayType: this.formData.effectDayType,
        effectDay:
          !this.isShowTime || !this.isShowDay
            ? this.formData.typeNum
            : this.formData.day,
        sendStartTime:
          this.formData.sendStartTime == ""
            ? ""
            : this.formData.sendStartTime + " 00:00:00",
        sendEndTime:
          this.formData.sendEndTime == ""
            ? ""
            : this.formData.sendEndTime + " 23:59:59",
        smsType: this.formData.smsType, //短信类型
        // sortField: this.formData.sortField,
        // asc: this.formData.asc,
        outerId: this.formData.type,
      };
      //单批次短信效果分析
      // var params = {
      //   flag: this.flag,
      //   startTime: this.formData.startTime,
      //   endTime: this.formData.endTime,
      //   outerId: officialObj.outerId,
      //   source: officialObj.source,
      // };
      // if (this.isAutoMarketingOfficial && this.batchValue != "") {
      //   // 自动化营销模型专属
      //   param.outerId = this.batchValue;
      //   param.source = "AUTO_MARKETING_BATCH";
      // }
      this.tableLoading = true;
      summaryV2Data(param)
        .then((res) => {
          if (res.code == 1) {
            this.tableLoading = false;
            this.tableData = res.data;
            this.tableData.forEach((item) => {
              if (!item.perCustomerTransaction) {
                item.perCustomerTransaction = 0;
              }
              item.clickRate = Number(item.clickRate);
              item.orderPayRate = Number(item.orderPayRate);
            });
            this.handleSortChange({ prop: "sendTime", order: "descending" });
            this.doLayouts()
            // this.tableData.forEach((item,index)=>{
            //   if(item.activityTitle=='总计') {
            //     this.tableData.splice(index,1)
            //   }

            // })
            // this.tableData.forEach((item,index)=>{
            //   if(item.sendTime) {
            //    item.newTime = new Date(item.sendTime).getTime()
            //   }
            //   if(item.roi) {
            //     let arr = item.roi.split(":")
            //      item.newRoi = arr[1]
            //   }
            // })

            // var effectData = res.data;
            // this.effectData = effectData;
            // this.browseGoods = JSON.parse(effectData.skuBrowsePvUvTop) || [];
            // this.cartGoods = JSON.parse(effectData.skuCartListTop) || [];
            // this.payGoods = JSON.parse(effectData.skuPayListTop) || [];
            // this.encapEffect(effectData);
            // this.getTendencyList();
          }
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    getEffectDatas() {
      //单批次
      var param = {
        flag: this.flag,
        startTime: this.formData_one.startTime,
        endTime: this.formData_one.endTime,
        source: this.activeTypesOne,
        dataFrom: this.dataFromsOne,
        outerId: this.formData_one.type, //短信类型
      };
      this.tableLoading = true;
      getOfficialData(param).then((res) => {
        if (res.code == "1") {
          this.tableLoading = false;
          var effectDatas = res.data;
          this.effectDatas = effectDatas;
          this.roi = effectDatas.roi
          // this.browseGoods_one = JSON.parse(effectDatas.skuBrowsePvUvTop) || [];
          // this.cartGoods_one = JSON.parse(effectDatas.skuCartListTop) || [];
          // this.payGoods_one = JSON.parse(effectDatas.skuPayListTop) || [];
          this.topGoods = effectDatas.skuTopVos || [];
          this.$refs.goodsTable.sort('payUserNum','descending');
          if (this.effectDatas.smsType == 1) {
            this.unitPrice = res.data.unitPriceDigital ? res.data.unitPriceDigital : "0.42"
          } else if(this.effectDatas.smsType == 2) {
            this.unitPrice = res.data.unitCardPrice ? res.data.unitCardPrice : "0.38"
          } else {
            this.unitPrice = res.data.unitPrice ? res.data.unitPrice : "0.05"
          }
          this.encapEffects(effectDatas);
          this.getTendencyLists();
        }
      });
    },
    // 效果分析数据封装
    encapEffect(data) {
      // 触达分析
      var targetCustomerMap = [
        {
          name: "预计触达人数：",
          value: data.sendSubmitNum,
          unit: "人",
        },
        {
          name: "实际触达人数：",
          value: data.sendNum,
          unit: "人",
        },
        {
          name: "触达率：",
          value: data.rate,
          unit: "%",
        },
      ];
      // 流量分析
      var accessResponseMap = [
        {
          name: "短链点击PV：",
          value: data.pv,
          unit: "次",
        },
        {
          name: "短链点击UV：",
          value: data.uv,
          unit: "人",
        },
        {
          name: "商品详情页PV：",
          value: data.skuPvNum,
          unit: "",
        },
        {
          name: "商品详情页UV：",
          value: data.skuUvNum,
          unit: "",
        },
        {
          name: "店铺首页PV：",
          value: data.shopPvNum,
          unit: "",
        },
        {
          name: "店铺首页UV：",
          value: data.shopUvNum,
          unit: "",
        },
      ];
      // 下单分析
      var takeOrderMap = [
        {
          name: "下单转化率：",
          value: data.orderRate,
          unit: "%",
        },
        {
          name: "下单人数：",
          value: data.ordPins,
          unit: "人",
        },
        {
          name: "下单金额：",
          value: data.ordAmount,
          unit: "元",
        },
        {
          name: "下单订单数：",
          value: data.ordNum,
          unit: "单",
        },
        {
          name: "下单件数：",
          value: data.ordQtty,
          unit: "件",
        },
      ];
      // 付款分析
      var payMap = [
        {
          name: "下单-付款转化率：",
          value: data.orderPayRate,
          unit: "%",
        },
        {
          name: "付款转化率：",
          value: data.payRate,
          unit: "%",
        },
        {
          name: "付款人数：",
          value: data.payPins,
          unit: "人",
        },
        {
          name: "付款金额：",
          value: data.payAmount,
          unit: "元",
        },
        {
          name: "付款订单数：",
          value: data.payNum,
          unit: "单",
        },
        {
          name: "付款件数：",
          value: data.payQtty,
          unit: "件",
        },
        {
          name: "客单价：",
          value: data.perCustomerTransaction,
          unit: "元",
        },
      ];
      // 兴趣分析
      var successMap = [
        {
          name: "关注商品人数：",
          value: data.followSkuNum,
          unit: "人",
        },
        {
          name: "关注店铺人数：",
          value: data.followShopNum,
          unit: "人",
        },
        {
          name: "加购人数：",
          value: data.cartNum,
          unit: "人",
        },
      ];
      // 会员购买分析
      var marketingInsightIntoMap = [
        {
          name: "已购会员购买客户数：",
          value: data.memberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买客户数：",
          value: data.brandMemberBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买客户数：",
          value: data.cardMemberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买新客户数：",
          value: data.brandMemberNewBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买新用户数：",
          value: data.cardMemberNewBuyPins,
          unit: "人",
        },
      ];
      var shopMemberType = this.shopMemberType;
      if (shopMemberType == "2" || shopMemberType == "4") {
        marketingInsightIntoMap.splice(1, 1);
        marketingInsightIntoMap.splice(2, 1);
      } else if (shopMemberType == "3" || shopMemberType == "5") {
        marketingInsightIntoMap.splice(2, 1);
        marketingInsightIntoMap.splice(3, 1);
      }
      var effectList = [
        {
          title: "触达分析",
          dataList: targetCustomerMap,
          icon: require("@/assets/images/new-effect/title0.svg"),
        },
        {
          title: "流量分析",
          dataList: accessResponseMap,
          icon: require("@/assets/images/new-effect/title1.svg"),
        },
        {
          title: "下单分析",
          dataList: takeOrderMap,
          icon: require("@/assets/images/new-effect/title2.svg"),
        },
        {
          title: "付款分析",
          dataList: payMap,
          icon: require("@/assets/images/new-effect/title3.svg"),
        },
        {
          title: "兴趣分析",
          dataList: successMap,
          icon: require("@/assets/images/new-effect/title4.svg"),
        },
        {
          title: "会员购买分析",
          dataList: marketingInsightIntoMap,
          icon: require("@/assets/images/new-effect/title5.svg"),
        },
      ];
      this.effectList = effectList;
    },
    encapEffects(data) {
      // 触达分析
      var targetCustomerMap = [
        {
          name: "预计触达人数：",
          value: data.sendSubmitNum,
          unit: "人",
        },
        {
          name: "实际触达人数：",
          value: data.sendNum,
          unit: "人",
        },
        {
          name: "触达率：",
          value: data.rate,
          unit: "%",
        },
      ];
      // 流量分析
      var accessResponseMap = [
        {
          name: "短链点击PV：",
          value: data.pv,
          unit: "次",
        },
        {
          name: "短链访点击UV：",
          value: data.uv,
          unit: "人",
        },
        {
          name: "商品详情页PV：",
          value: data.skuPvNum,
          unit: "",
        },
        {
          name: "商品详情页UV：",
          value: data.skuUvNum,
          unit: "",
        },
        {
          name: "店铺首页PV：",
          value: data.shopPvNum,
          unit: "",
        },
        {
          name: "店铺首页UV：",
          value: data.shopUvNum,
          unit: "",
        },
      ];
      // 下单分析
      var takeOrderMap = [
        {
          name: "下单转化率：",
          value: data.orderRate,
          unit: "%",
        },
        {
          name: "下单人数：",
          value: data.ordPins,
          unit: "人",
        },
        {
          name: "下单金额：",
          value: data.ordAmount,
          unit: "元",
        },
        {
          name: "下单订单数：",
          value: data.ordNum,
          unit: "单",
        },
        {
          name: "下单件数：",
          value: data.ordQtty,
          unit: "件",
        },
      ];
      // 付款分析
      var payMap = [
        {
          name: "下单-付款转化率：",
          value: data.orderPayRate,
          unit: "%",
        },
        {
          name: "付款转化率：",
          value: data.payRate,
          unit: "%",
        },
        {
          name: "付款人数：",
          value: data.payPins,
          unit: "人",
        },
        {
          name: "付款金额：",
          value: data.payAmount,
          unit: "元",
        },
        {
          name: "付款订单数：",
          value: data.payNum,
          unit: "单",
        },
        {
          name: "付款件数：",
          value: data.payQtty,
          unit: "件",
        },
        {
          name: "客单价：",
          value: data.perCustomerTransaction,
          unit: "元",
        },
      ];
      // 兴趣分析
      var successMap = [
        {
          name: "关注商品人数：",
          value: data.followSkuNum,
          unit: "人",
        },
        {
          name: "关注店铺人数：",
          value: data.followShopNum,
          unit: "人",
        },
        {
          name: "加购人数：",
          value: data.cartNum,
          unit: "人",
        },
      ];
      // 会员购买分析
      var marketingInsightIntoMap = [
        {
          name: "已购会员购买客户数：",
          value: data.memberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买客户数：",
          value: data.brandMemberBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买客户数：",
          value: data.cardMemberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买新客户数：",
          value: data.brandMemberNewBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买新用户数：",
          value: data.cardMemberNewBuyPins,
          unit: "人",
        },
      ];
      var shopMemberType_one = this.shopMemberType_one;
      if (shopMemberType_one == "2" || shopMemberType_one == "4") {
        marketingInsightIntoMap.splice(1, 1);
        marketingInsightIntoMap.splice(2, 1);
      } else if (shopMemberType_one == "3" || shopMemberType_one == "5") {
        marketingInsightIntoMap.splice(2, 1);
        marketingInsightIntoMap.splice(3, 1);
      }
      var effectList = [
        {
          title: "触达分析",
          dataList: targetCustomerMap,
          icon: require("@/assets/images/new-effect/title0.svg"),
        },
        {
          title: "流量分析",
          dataList: accessResponseMap,
          icon: require("@/assets/images/new-effect/title1.svg"),
        },
        {
          title: "下单分析",
          dataList: takeOrderMap,
          icon: require("@/assets/images/new-effect/title2.svg"),
        },
        {
          title: "付款分析",
          dataList: payMap,
          icon: require("@/assets/images/new-effect/title3.svg"),
        },
        {
          title: "兴趣分析",
          dataList: successMap,
          icon: require("@/assets/images/new-effect/title4.svg"),
        },
        {
          title: "会员购买分析",
          dataList: marketingInsightIntoMap,
          icon: require("@/assets/images/new-effect/title5.svg"),
        },
      ];
      this.effectList_one = effectList;
    },
    getTendencyList() {
      title;
      var tendencyMap = [
        {
          title: "流量趋势",
          data: [
            {
              key: "pv",
              name: "短链接点击PV",
            },
            {
              key: "uv",
              name: "短链接点击UV",
            },
            {
              key: "skuPvNum",
              name: "商品详情页PV",
            },
            {
              key: "skuUvNum",
              name: "商品详情页UV",
            },
            {
              key: "shopPvNum",
              name: "店铺首页PV",
            },
            {
              key: "shopUvNum",
              name: "店铺首页UV",
            },
          ],
        },
        {
          title: "转化趋势",
          data: [
            {
              key: "ordPins",
              name: "下单人数",
            },
            {
              key: "ordAmount",
              name: "下单金额",
            },
            {
              key: "ordNum",
              name: "下单订单数",
            },
            {
              key: "ordQtty",
              name: "下单件数",
            },
            {
              key: "payPins",
              name: "付款人数",
            },
            {
              key: "payAmount",
              name: "付款金额",
            },
            {
              key: "payNum",
              name: "付款订单数",
            },
            {
              key: "payQtty",
              name: "付款件数",
            },
          ],
        },
        {
          title: "兴趣趋势",
          data: [
            {
              key: "followSkuNum",
              name: "关注商品人数",
            },
            {
              key: "followShopNum",
              name: "关注店铺人数",
            },
            {
              key: "cartNum",
              name: "加购人数",
            },
          ],
        },
        {
          title: "会员趋势",
          data: [
            {
              key: "memberBuyPins",
              name: "已购会员购买客户数",
            },
            {
              key: "brandMemberBuyPins",
              name: "品牌开卡会员购买客户数",
            },
            {
              key: "brandMemberNewBuyPins",
              name: "品牌开卡会员购买新客户数",
            },
            {
              key: "cardMemberBuyPins",
              name: "店铺开卡会员购买客户数",
            },
            {
              key: "cardMemberNewBuyPins",
              name: "店铺开卡会员购买新客户数",
            },
          ],
        },
      ];
      var shopMemberType = this.shopMemberType;
      if (shopMemberType == "2" || shopMemberType == "4") {
        // 显示店铺开卡会员
        tendencyMap[3].data.splice(1, 2);
      } else if (shopMemberType == "3" || shopMemberType == "5") {
        // 显示品牌开卡会员
        tendencyMap[3].data.splice(3, 2);
      }
      this.trendingListX = tendencyMap;
      var firstItem = tendencyMap[0].data[0];
      this.trendKey = firstItem.key;
      this.getTrendValue(firstItem);
    },
    getTendencyLists() {
      var tendencyMap = [
        {
          title: "流量趋势",
          data: [
            {
              key: "pv",
              name: "短链接点击PV",
            },
            {
              key: "uv",
              name: "短链接点击UV",
            },
            {
              key: "skuPvNum",
              name: "商品详情页PV",
            },
            {
              key: "skuUvNum",
              name: "商品详情页UV",
            },
            {
              key: "shopPvNum",
              name: "店铺首页PV",
            },
            {
              key: "shopUvNum",
              name: "店铺首页UV",
            },
          ],
        },
        {
          title: "转化趋势",
          data: [
            {
              key: "ordPins",
              name: "下单人数",
            },
            {
              key: "ordAmount",
              name: "下单金额",
            },
            {
              key: "ordNum",
              name: "下单订单数",
            },
            {
              key: "ordQtty",
              name: "下单件数",
            },
            {
              key: "payPins",
              name: "付款人数",
            },
            {
              key: "payAmount",
              name: "付款金额",
            },
            {
              key: "payNum",
              name: "付款订单数",
            },
            {
              key: "payQtty",
              name: "付款件数",
            },
          ],
        },
        {
          title: "兴趣趋势",
          data: [
            {
              key: "followSkuNum",
              name: "关注商品人数",
            },
            {
              key: "followShopNum",
              name: "关注店铺人数",
            },
            {
              key: "cartNum",
              name: "加购人数",
            },
          ],
        },
        {
          title: "会员趋势",
          data: [
            {
              key: "memberBuyPins",
              name: "已购会员购买客户数",
            },
            {
              key: "brandMemberBuyPins",
              name: "品牌开卡会员购买客户数",
            },
            {
              key: "brandMemberNewBuyPins",
              name: "品牌开卡会员购买新客户数",
            },
            {
              key: "cardMemberBuyPins",
              name: "店铺开卡会员购买客户数",
            },
            {
              key: "cardMemberNewBuyPins",
              name: "店铺开卡会员购买新客户数",
            },
          ],
        },
      ];
      var shopMemberType_one = this.shopMemberType_one;
      if (shopMemberType_one == "2" || shopMemberType_one == "4") {
        // 显示店铺开卡会员
        tendencyMap[3].data.splice(1, 2);
      } else if (shopMemberType_one == "3" || shopMemberType_one == "5") {
        // 显示品牌开卡会员
        tendencyMap[3].data.splice(3, 2);
      }
      this.trendingListX_one = tendencyMap;
      var firstItem = tendencyMap[0].data[0];
      this.trendKey_one = firstItem.key;
      this.getTrendValues(firstItem);
    },
    getTrendValue(item) {
      var key = item.key;
      var tendencyList = this.effectData.tendencyList;
      if (!tendencyList) {
        //空数据给默认
        this.seriesData = [
          {
            name: item.name,
            data: [0, 0],
          },
        ];
        this.echartsDate = [this.formData.startTime, this.formData.endTime];
        return;
      }
      var dataList = [];
      var echartsDate = [];
      tendencyList.forEach((item) => {
        dataList.push(item[key]);
        echartsDate.push(item.effectDate);
      });
      this.echartsDate = echartsDate;
      this.seriesData = [
        {
          name: item.name,
          data: dataList,
        },
      ];
    },
    getTrendValues(item) {
      var key = item.key;
      var tendencyList = this.effectDatas.tendencyList;
      if (!tendencyList) {
        //空数据给默认
        this.seriesData = [
          {
            name: item.name,
            data: [0, 0],
          },
        ];
        this.echartsDate = [
          this.formData_one.startTime,
          this.formData_one.endTime,
        ];
        return;
      }
      var dataList = [];
      var echartsDate = [];
      tendencyList.forEach((item) => {
        dataList.push(item[key]);
        echartsDate.push(item.effectDate);
      });
      this.echartsDate = echartsDate;
      this.seriesData = [
        {
          name: item.name,
          data: dataList,
        },
      ];
    },
    //数据汇总导出
    getphone1(val) {
      var param = {
        startTime:
          this.formData.effectDayType == 1
            ? this.formData.startTime
            : undefined,
        endTime:
          this.formData.effectDayType == 1 ? this.formData.endTime : undefined,
        source: this.activeTypes,
        dataFrom: this.dataFroms,
        exportRemark: val,
        sendStartTime: this.formData.sendStartTime + " 00:00:00",
        sendEndTime: this.formData.sendEndTime + " 23:59:59",
        smsType: this.formData.smsType, //短信类型
        exportType: "短信效果汇总-数据总览",
        effectDayType: this.formData.effectDayType,
        effectDay: this.formData.typeNum,
      };
      summaryExport(param).then((res) => {
        if (res.code == 1) {
          this.control = true;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //单批次导出
    getphone2(val) {
      var param = {
        flag: this.flag,
        startTime: this.formData_one.startTime,
        endTime: this.formData_one.endTime,
        source: this.activeTypesOne,
        exportRemark: val,
        dataFrom: this.dataFromsOne,
        outerId: this.formData_one.type, //短信类型
        exportType: "短信效果汇总-单批次分析",
      };
      summaryExport1(param).then((res) => {
        if (res.code == 1) {
          this.control1 = true;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleChange() {
      this.formData.type = "";
    },
    handleChanges() {
      this.formData.typeNum = "";
    },
    handleChange_one() {
      this.formData_one.types = "";
    },
    reset() {
      this.formData.effectDayType = 0;
      this.formData.day = "";
      this.formData.typeNum = "7";
      this.formData.effectDay = "30";
      this.formData.smsType = "";
      this.formData.activeType = "";
      this.activeTypes = ""; //PRECISION_MARKETING
      this.isShowActiveSelect = false;
      this.formData.type = null;
      this.switchType(this.formData.effectDay);
      this.getEffectData();
    },
    reset_one() {
      this.formData_one.smsType = "";
      this.formData_one.activeType = "1";
      this.switchType2("7");
      this.getEffectDatas();
    },
    // 字段配置
    fieldSetting() {
      this.isShowSetting = true;
    },
    //导出数据
    exportData() {
      this.control = true;
    },
    exportDataOne() {
      this.control1 = true;
    },
    switchTab(val) {
      let index = val.index;
      this.switchIndex = index;
      var flagList = ["", false, true];
      this.flag = flagList[this.switchIndex];
      this.getEffectDatas();
    },
    //单批次短信效果分析
    getSelectBatch() {
      let nums = {
        source: this.activeTypesOne,
        dataFrom: this.dataFromsOne,
      };
      getSelectBatch(nums).then((res) => {
        this.timeTypes = res.data;
        this.formData_one.type = res.data[0].outerId;
      });
    },
    // 列表排序
    selectChange(value) {
      this.$refs.goodsTable.sort(value,'descending');
    },
    //end
  },
};
</script>

<style lang="scss" scoped>
.intelligentBox {
  margin: 11px 20px;
  min-width: 1130px;
  .tab-line {
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;
    .tab-item {
      text-align: center;
      width: 106px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }
      &.active {
        border-top: 2px;
        span {
          display: block;
          background: #fff;
        }
      }
    }
  }
  .tab_item_box {
    padding: 0px 27px 20px;
    .status_btn {
      font-size: 14px;
      width: 98px;
      font-size: 14px;
      height: 32px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .status_btn2 {
      margin-left: 8px;
      color: #666666;
      font-size: 14px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .search_item {
      display: inline-block;
      margin-right: 79px;
      margin-bottom: 16px;
      color: #333;
    }
  }
  .tab_item_box_one {
    padding: 0px 27px 10px 28px;
  }
  .create_btn3 {
    width: 98px;
    height: 32px;
    opacity: 1;
    border-radius: 3px;
    display: inline-block;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
  .right_allBtn {
    float: right;
    color: #333;
    font-size: 14px;
  }
  .table-center {
    margin: 2px 28px 10px 28px;
    padding-bottom: 20px;
  }
  .el-icon-edit-outline {
    cursor: pointer;
  }
  .table-header__bg {
    background-color: #fafafa;
    & th {
      background-color: transparent;
    }
  }
  .headForm {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    padding: 0 0 30px 0;
    border-radius: 6px;
    h4 {
      box-sizing: border-box;
      padding-left: 28px;
      margin: 0;
      height: 54px;
      line-height: 52px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
      color: #2e3458;
    }
  }

  .section-right-content-box {
    // min-width: 1066px;
    background-color: #fff;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    padding: 26px 30px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    opacity: 1;
    margin-top: 20px;

    .search-box {
      height: 80px !important;

      .timePicker {
        vertical-align: middle;
        margin-right: 10px;
      }

      .button {
        vertical-align: middle;
      }
    }

    .headForm {
      margin-left: -20px;
    }
    .background {
      // margin-bottom: 20px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
      .question_iconText {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      .question_icon {
        width: 14px;
        height: 14px;
        // color: #cccccc;
        display: inline-block;
        line-height: 12px;
        text-align: center;
        border-radius: 14px;
        border: 1px solid #7f85e9;
        font-size: 10px;
        font-weight: normal;
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
        }
      }
    }

    .trend-wrap {
      margin-top: 23px;
      border: 1px solid #eee;
      .trend-box-x {
        border-radius: 4px 4px 0 0;
        background: #fafafa;
        font-size: 14px;
        color: #333;
        padding: 32px 40px;
        .trend-item {
          margin-bottom: 16px;
          &:last-child {
            margin-bottom: 0;
          }
          .type-title {
            font-weight: bold;
            display: inline-block;
            width: 80px;
            vertical-align: text-top;
          }
          .trend-radio {
            display: inline-block;
            width: calc(100% - 80px);
            vertical-align: text-top;
            /deep/.el-radio__label {
              font-size: 14px;
            }
            /deep/.el-radio {
              margin-bottom: 5px;
            }
          }
        }
      }

      .trend-box {
        background: #fff;
        border-radius: 0 0 4px 4px;
        padding: 44px 45px;
        .trend-tab {
          background: #eeeeee;
          display: inline-block;
          padding: 5px;
          .trend-item {
            cursor: pointer;
            width: 96px;
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            color: #666;
            display: inline-block;
            text-align: center;
            &.active {
              background: #fff;
              color: #fe4d45;
            }
          }
        }
      }
    }

    .top-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title-left {
        display: flex;
        align-items: center;
      }
    }
  }
  .good-analysis {
    .title-line {
      font-size: 14px;
      color: #333;
      margin-bottom: 25px;
    }
    .goods-item {
      width: 100%;
      margin-top: 20px;
      margin-right: 20px;
      margin-bottom: 20px;
      vertical-align: text-top;
      // @media screen and (max-width: 1400px) {
      //   width: 440px;
      // }
      &:nth-child(4) {
        margin-right: 0;
      }
      display: inline-block;
      .goods-title {
        margin-bottom: 9px;
        color: #000000;
        font-size: 14px;
        line-height: 16px;
      }
      .goods-box {
        & > div {
          display: inline-block;
          margin-left: 8px;
        }
        img {
          width: 38px;
          height: 38px;
        }
        .shop-title {
          font-size: 14px;
          color: #666;
          width: 160px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .sku-line {
          color: #000;
          font-size: 14px;
          width: 160px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .box-content {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //设置超出几行省略内容
      text-overflow: ellipsis;
      overflow: hidden;
    }
}

/** 表单搜索  */
.search-box {
  margin-top: 20px;
  padding-bottom: 20px;
  .el_btn {
    text-align: center;
    .search {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .el-input,
  .el-select {
    width: 280px;
  }
  .my_select_time {
    display: flex;
    align-items: center;
  }
  .btn_group {
    text-align: center;
    .search {
      color: rgb(254, 77, 69);
      background-color: #ffffff;
      border: 1px solid rgb(254, 77, 69);
      font-size: 14px;
    }
    .search:hover {
      color: #ffffff;
      background-color: rgb(254, 77, 69);
    }
  }
  .tab-roi-box {
    margin: 20px 20px 0 20px;
  }
  .top-content {
    margin-left: 20px;
    .top-item {
      display: inline-block;
      vertical-align: text-top;
      width: 250px;
      margin-bottom: 20px;
      background: linear-gradient(
        180deg,
        rgba(39, 104, 255, 0.1) 0%,
        rgba(39, 104, 255, 0) 48%
      );
      border-image: linear-gradient(
          180deg,
          rgba(234, 241, 255, 1),
          rgba(255, 255, 255, 1)
        )
        1 1;
      border-radius: 8px;
      .title {
        font-size: 16px;
        // font-weight: bold;
        color: #333;
        text-align: center;
        line-height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .content {
        height: 233px;
        box-sizing: border-box;
        padding: 16px 19px;
        font-size: 13px;
        color: #333;
        line-height: 25px;
      }
    }
  }
  .trend-box-x {
    font-size: 14px;
    color: #333;
    margin-top: 16px;
    .trend-item {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      .type-title {
        display: inline-block;
        width: 80px;
        vertical-align: text-top;
        color: #666666;
      }
      .trend-radio {
        display: inline-block;
        width: calc(100% - 80px);
        vertical-align: text-top;
        color: #333;
        /deep/.el-radio__label {
          font-size: 14px;
        }
        /deep/.el-radio {
          margin-bottom: 5px;
        }
      }
    }
  }
}
.tip-box {
  display: inline-block;
  padding-left: 12px;
  padding-right: 12px;
  text-align: left;
  // line-height: 21px;
  font-size: 14px;
  // margin-top: 12px;
  color: #999999;
  background: #fffaee;
  // position: relative;
  // margin: 20px 0 16px 0;
  border-radius: 28px;
  line-height: 28px;
  height: 28px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  // span{
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
  // }
  .warning-icon {
    color: #ffb95e;
    font-size: 14px;
    // position: absolute;
    left: 5px;
    top: 7px;
  }
}
.info-box {
    display: flex;
    flex-wrap: nowrap;
    padding: 20px 28px;
    .roi-box-wrap {
      display: inline-block;
      vertical-align: middle;
    }
    .roi-box {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
      width: 300px;
      box-sizing: border-box;
      padding: 16px 14px;
      background-color: #fff6f6;
      border: 1px solid #fe8f8a;
      border-radius: 4px;
      .roi {
        background-color: #fe8f8a;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        width: 46px;
        height: 46px;
        border-radius: 6px;
        line-height: 46px;
        text-align: center;
        margin-right: 12px;
      }
      .roi-data {
        color: #333;
        font-size: 14px;
        padding-top: 2px;
        .value {
          color: #fe4d45;
          font-weight: bold;
          font-size: 20px;
          margin-top: 7px;
        }
        .update-btn {
          cursor: pointer;
          color: #7f85e9;
          margin-left: 45px;
          font-size: 14px;
        }
        .question_icon {
          width: 14px;
          height: 14px;
          color: #ccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #ccc;
          font-size: 12px;
          font-weight: normal;
        }
        .question_icon:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
        }
      }
    }
    .task-content {
      font-size: 14px;
      line-height: 20px;
      color: #333;
      display: inline-block;
      vertical-align: middle;
      margin-left: 34px;
      div {
        margin-bottom: 6px;
      }
      .send-status {
        color: #000;
        margin-right: 60px;
      }
      .num {
        color: #fe4d45;
      }
      .rich_title {
        color: #7f85e9;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
.table-style {
  /deep/ .el-table th.is-leaf {
    height: 50px !important;
  }
  /deep/.el-table__fixed-body-wrapper .el-table__body {
    padding-bottom: 2px !important;
  }
  /deep/ .el-table th > .cell {
    height: 40px !important;
    line-height: 40px !important;
    font-size: 14px;
    font-family: Microsoft YaHei;
    -webkit-font-smoothing: antialiased;
    color: #333;
  }
}
</style>
